import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import Modal from '../Modal/Modal';
import PolicyChanges from '../Storyblok/PolicyChanges/PolicyChanges';

const modalWrapperSx = (theme) => ({
  padding: '20px',
  '& h2': {
    ...theme.mixins.marketplaceModalTitleStyles,
  },
});

const modalTextWrapperSx = {
  marginTop: '20px',
  marginBottom: '40px',
  whiteSpace: 'pre-line',
};

/**
 * Modal component that displays when policies have changed and require user acknowledgment
 *
 * @component
 * @param {object} props
 * @param {boolean} props.isOpen - Controls whether the modal is displayed
 * @param {Function} props.onClose - Handler called when modal is closed
 * @param {Function} props.onButtonClick - Handler called when acknowledgment button is clicked
 * @param {Function} props.onManageDisableScrolling - Handler to manage scroll behavior when modal opens/closes
 * @returns {React.ReactNode} A modal displaying policy changes that require acknowledgment
 */

const PolicyHasChangedModal = ({ isOpen, onClose, onButtonClick, onManageDisableScrolling }) => {
  const handleClick = (event) => {
    onButtonClick(event);
  };

  return (
    <Modal
      id="policyAcknowledgment"
      isOpen={isOpen}
      onClose={onClose}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
    >
      <Box sx={modalWrapperSx}>
        <FormattedMessage id="Page.policyAcknowledgmentChanged" tagName="p" />
        <Box sx={modalTextWrapperSx}>
          <PolicyChanges />
        </Box>
        <Button color="success" onClick={handleClick} variant="contained">
          <FormattedMessage id="Page.policyAcknowledgment.ok" />
        </Button>
      </Box>
    </Modal>
  );
};

export default PolicyHasChangedModal;
